import { GridPostParams } from "common/models/utility-models/list-utility.model";

export class InternshipReportsGridPostParams extends GridPostParams {
    reportTypeFlag: number = 5;
    search_keyword: any = '';
    region_search: string = '';
    batch_search: any = '';
    branch_search: any = '';
    state_search: any = '';
    gender_search: string = ''
    status_search: any = '';
    internship_company_search: any = '';
    considerYear_search: any = '';
}